$('document').ready(function(){
  var checkboxes = document.getElementById("checkboxes");
  var required =  document.getElementById('multiselect-container').querySelector('select').hasAttribute('required');

  $('#checkboxes input[type="checkbox"]').on('change', function () {
    let select_elem_id = $(this).data('selectid');
    let select_elem = document.getElementById(select_elem_id);

    let select_elem_val =  (select_elem.value == "") ? [] : select_elem.value.split(', ');
    
    if (this.checked) {
      select_elem_val.push(this.value);
    } else {

      let index = select_elem_val.indexOf(this.value);
      if (index > -1){
        select_elem_val.splice(index, 1);
      }
    }
    
    select_elem.value = select_elem_val.join(', ');

    if (required) {
      if (select_elem.value == '')
        document.getElementById('multiselect-container').querySelector('select').setAttribute('required', true);
      else
        document.getElementById('multiselect-container').querySelector('select').removeAttribute('required');
    }

  });
  
  $(document).on("click", function() {
    if (expanded && !$(event.target).closest("#multiselect-container, #checkboxes").length) {
      checkboxes.style.display = "none";
      expanded = false;
    }
  });
  
});

var expanded = false;

function showCheckboxes() {
  if (!expanded) {
    checkboxes.style.display = "block";
    offsetCalculate();
    expanded = true;
  } else {
    checkboxes.style.display = "none";
    expanded = false;
  }
}

function offsetCalculate(){
  let parent_position = $('#multiselect-container').offset();
  let offsets =  document.getElementById('multiselect-container').getBoundingClientRect();
  $('#checkboxes').offset({
    'top':parent_position.top + offsets.height,
    'left': parent_position.left
  });
  $('#checkboxes').css('width', offsets.width);
}

$(window).resize(function(){
  if (expanded)
    offsetCalculate();
});